import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyA7t7Y5ONfHhhpCpeTet_Cgsj8niD-GTVM",
  authDomain: "hopphomesdb-2025.firebaseapp.com",
  projectId: "hopphomesdb-2025",
  storageBucket: "hopphomesdb-2025.firebasestorage.app",
  messagingSenderId: "771783897038",
  appId: "1:771783897038:web:cb89ac8aed960a864a459f",
  measurementId: "G-44M6TJBVWX"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app); // régió eltávolítva production kompatibilitásért

export { app, db, auth, functions };